<template>
  <div class="customer-service-container customer" :class="{ 'customer-m': isMobile, 'show-zindex': show }">
    <transition name="el-zoom-in-bottom">
      <div v-show="show" id="dragPanel" class="yks-service-contents">
        <div class="flex v-center service-title">
          <div id="dragIcon" class="yks-drag"></div>
          <el-image
            src="https://obs-ogt.obs.cn-east-3.myhuaweicloud.com:443/tinymce/1685178214352-server-cs.png"></el-image>
          <div class="flex-1 ml10 service-infos">
            <div>{{ helpRobotName }}</div>
            <div v-if="consultationHotline">咨询热线: {{ consultationHotline }}</div>
          </div>
          <i class="el-icon-minus" @click="show = false"></i>
        </div>
        <!-- :height="currentMode === '1' ? 'calc(100% - 200px)' : 'calc(100% - 150px)'" -->
        <el-scrollbar v-loading="loadingText" element-loading-text="请稍等..."
          id="scrollbar" class="yks-app-scrollbar">
          <div class="yks-contents">
            <div v-if="loading" class="flex h-center mb10">
              <i class="el-icon-loading"></i>
              <span class="fs-12 info ml10">数据加载中...</span>
            </div>
            <template v-for="(item, index) in smsList">
              <div v-if="item.type === '2' || item.type === '6' || item.type === '7'" :key="`list${index}`"
                class="flex v-start mb10">
                <el-avatar src="https://obs-ogt.obs.cn-east-3.myhuaweicloud.com:443/tinymce/1685178214352-server-cs.png"
                  shape="circle" size="small"></el-avatar>
                <div class="flex-1 msg-content left-content">
                  <div class="mb10 yks-contents-left ql-container" @click="imageChgange($event, item.content)">
                    <div v-html="item.content" class="ql-editor"></div>
                  </div>
                </div>
              </div>
              <div v-if="item.type === '1'" class="flex v-start mb10" :key="`list${index}`">
                <div class="flex-1 tr msg-content right-content">
                  <div class="mb10 yks-contents-right" @click="imageChgange($event, item.content)">
                    <div v-html="item.content" class="ql-editor tl"></div>
                  </div>
                </div>
                <el-avatar src="https://obs-ogt.obs.cn-east-3.myhuaweicloud.com:443/tinymce/1683875908054-user.png"
                  shape="circle" size="small"></el-avatar>
              </div>
              <el-divider v-if="item.type === '3' || item.type === '8'" :key="`list${index}`">
                {{ item.content }}
              </el-divider>
              <div v-if="item.type === '4'" :key="`list${index}`" class="flex v-start mb10">
                <el-avatar src="https://obs-ogt.obs.cn-east-3.myhuaweicloud.com:443/tinymce/1685178214352-server-cs.png"
                  shape="circle" size="small"></el-avatar>
                <div class="flex-1 msg-content left-content">
                  <div class="mb10 yks-contents-sms">
                    <div class="flex v-center guess">
                      <span class="flex-1 sms-batch">猜你想问？</span>
                      <el-button type="text" class="fs-12 button-text" @click="changeBatch(item)">换一批问题</el-button>
                    </div>
                    <div v-for="(row, index) in item.list" :key="`${row.id}-${index}`">
                      <el-link type="primary" :underline="false" class="fs-12" @click="handleClickLink(row)">{{ index + 1
                        }}、{{ row.questionName }}</el-link>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="item.type === '9'" :key="`list${index}`" class="flex v-start mb10">
                <el-avatar src="https://obs-ogt.obs.cn-east-3.myhuaweicloud.com:443/tinymce/1685178214352-server-cs.png"
                  shape="circle" size="small"></el-avatar>
                <div class="flex-1 msg-content left-content">
                  <div class="mb10 yks-contents-sms">
                    <div class="flex v-center guess">
                      <span class="flex-1 sms-batch">请选择你需要的服务</span>
                    </div>
                    <div v-for="(row, index) in item.content" :key="`${row.id}-${index}`"
                      @click="handleClickCustomer(row)">
                      <el-link type="primary" :underline="false" class="fs-12 skill"
                        :class="{ disabled: selectedSkill }">{{ index + 1 }}、{{ row.label }}</el-link>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="item.type === '5'" :key="`list${index}`" class="flex h-center mb20">
                <!-- <el-link type="primary" :underline="false" class="fs-12" @click="handleNextContent">
                                  {{ item.content }}
                              </el-link> -->
                <span class="fs-12"> {{ item.content }}</span>
              </div>
            </template>
          </div>
        </el-scrollbar>
        <div class="service-bottom">
          <div class="sms-tabs" v-show="currentMode === '1'">
            <el-tabs v-model="editableTabsValue" type="card" @tab-click="handleClickTab" class="tabs-customer">
              <el-tab-pane v-for="(item, index) in tabList" :key="`tabList${index}`" :label="item.key"
                :name="item.value">
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="sms-tabs" v-show="currentMode === '2'">
            <div class="tool-bar">
              <el-tooltip effect="dark" content="截图发送" placement="top">
                <i class="el-icon-scissors icon-message-top" @click="handleClickScreenShot"></i>
              </el-tooltip>
            </div>
          </div>
          <div class="flex v-start yks-content">
            <el-input ref="enterings" v-model.trim="content" :rows="2" type="textarea" maxlength="100" show-word-limit
              placeholder="请输入内容" class="flex-1 mr10" clearable resize="none" :disabled="inputDisabled"
              @keyup.enter.native="handleEnterSeed" id="testPasteInput">
            </el-input>
            <el-button type="primary" size="mini" :disabled="tabLoading" @click="handleSeed">咨询</el-button>
          </div>
        </div>
      </div>
    </transition>
    <div class="customer-service-icon" v-if="!show" @click="handleShow">
      <img src="../../assets/image/server.png">
      <span class="icon-label">咨询</span>
    </div>
  </div>
</template>
<script>
import { handleFullScreen, debounceFn } from '@/util'
import common from '@/util/common'
import TencentCloudChat from '@tencentcloud/chat'
import TIMUploadPlugin from 'tim-upload-plugin'
import ScreenShot from 'js-web-screen-shot'
import { searchQuestion, getDictType, searchQuestionDetail, getIMTempCredentialApi, fetchConsultContent, getSkillGroupListApi, bindCandidateSkillGroupApi } from '@/model/yks-customer-model'
export default {
  name: 'customerServiceDialog',
  data() {
    // In the following line, you should include the prefixes of implementations you want to test.
    const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB
    // DON'T use "var indexedDB = ..." if you're not in a function.
    // Moreover, you may need references to some window.IDB* objects:
    const IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction || window.msIDBTransaction || { READ_WRITE: 'readwrite' } // This line should only be needed if it is needed to support the object's constants for older browsers
    const IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange
    return {
      // 考网机构id 暂时写死
      officeId: 'ZA285336629483483136503764717441',
      examId: '',
      isMobile: false,
      show: false,
      loading: false,
      tabLoading: false,
      loadingText: false,
      skillLock: false,
      content: '',
      editableTabsValue: '',
      srcUrl: '',
      srcList: [],
      list: [],
      tabList: [],
      queueList: [],
      ServiceDb: {
        indexedDB,
        IDBTransaction,
        IDBKeyRange,
        requestDB: null,
        db: null
      },
      pageOption: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      inputDisabled: false,

      sdkReady: false,

      dbName: 'CustomerService',
      // 当前模式 '1'智能机器人 ｜ '2' 人工客服
      currentMode: '1',

      systemName: '',
      consultationHotline: '',
      helpRobotName: '',
      contactUsDescription: '',
      openWindowDescription: '',
      useHotline: false,

      customerUserId: '',
      SDKAppID: null, // SDKAppID

      userSig: '',

      userId: '', // User ID
      userName: '', // User Name
      userInfo: '',

      // chat实例
      chat: null,

      // 是否可以更新
      canUpdate: true,

      // 考生登录还是访客
      candidateFlag: false,

      // 更新timer
      updateTimer: null,

      selectedSkill: false,

    }
  },
  mounted() {

  },
  created() {
    sessionStorage.setItem('currentMode', '1')
    this.registerUser(
        {
            userId: null,
            userName: null,
            userInfo:{}
        },
        false
    )
    this.handleClickCustomer = debounceFn(this.handleClickCustomer, 1000)
  },
  computed: {
    smsList() {
      return this.list.sort((a, b) => a.timeStamp - b.timeStamp)
    },
  },
  watch: {

  },
  methods: {
    changeQueueList(value) {
      const fun = window._.debounce(() => {
        // 队列出栈
        if (this.queueList.length) {
          const data = this.queueList.shift()
          this.insertDbContent(data)
        }
      }, 500)
      if (value.length) {
        fun()
      }
    },

    async registerUser(option, candidateFlag) {
      console.log('注册考生信息中====》', this.canUpdate)
      this.candidateFlag = candidateFlag
      if (!this.canUpdate) return
      this.canUpdate = false
      try {
        if (!option.userId) {
          if (sessionStorage.getItem('customer_user_id')) {
            this.userId = sessionStorage.getItem('customer_user_id')
          } else {
            const generateUserId = `user_${Date.now()}_${Math.random().toString().slice(2)}`
            sessionStorage.setItem('customer_user_id', generateUserId)
            this.userId = generateUserId
          }
        } else {
          sessionStorage.removeItem('customer_user_id')
          this.userId = option.userId
        }
        if (!option.userName) {
          if (sessionStorage.getItem('customer_user_name')) {
            this.userName = sessionStorage.getItem('customer_user_name')
          } else {
            const generateUserName = `访客_${Math.random().toString().slice(2)}`
            sessionStorage.setItem('customer_user_name', generateUserName)
            this.userName = generateUserName
          }
        } else {
          sessionStorage.removeItem('customer_user_name')
          this.userName = option.userName
        }

        this.userInfo = option.userInfo
        console.log('this.userInfo');
        console.log(this.userInfo);
        await this.getConditionalParams()
        this.initBaseData()
      } catch (e) {
        this.canUpdate = true
      } finally {
        if (this.updateTimer) {
          clearTimeout(this.updateTimer)
          this.updateTimer = null
        }
        this.updateTimer = setTimeout(() => {
          this.canUpdate = true
        }, 5 * 1000)
      }
    },

    async getConditionalParams() {
      this.initConsultContent()
      await this.initIMParams()
    },

    async initIMParams() {
      console.log('initIMParams');
      const { data } = await getIMTempCredentialApi({ candidateId: this.userId, examId: this.examId, officeId: this.officeId })
      let res = data.data
      this.customerUserId = res.passExamUserId
      this.SDKAppID = res.sdkAppId // SDKAppID
      this.userSig = res.userSig
    },

    async initConsultContent() {
      const { data } = await fetchConsultContent({ keyword: this.officeId, officeId: this.officeId })
      let res = data.data
      this.systemName = res.systemName
      this.helpRobotName = res.helpRobotName || '智能小助手'
      this.consultationHotline = res.hotlineTelephone
      this.openWindowDescription = res.openWindowDescription || '欢迎使用在线考试系统，智能小助手为您服务，请输入您要了解的内容！'
      this.contactUsDescription = res.contactUsDescription || '小助手不知道您在说什么，可以尝试联系人工客服！'
      this.useHotline = res.useHotline
    },

    async resetData() {
      this.loading = false
      this.tabLoading = false
      this.loadingText = false
      this.content = ''
      this.editableTabsValue = ''
      this.srcUrl = ''
      this.srcList = []
      this.list = []
      this.tabList = []
      this.queueList = []
      this.pageOption = {
        page: 1,
        pageSize: 50,
        total: 0
      }
      this.inputDisabled = false
      this.sdkReady = false
      this.candidateFlag = false
      this.updateTimer = null
      if (this.chat) {
        try {
          await this.chat.destroy()
          this.chat = null
        } catch (error) {
          this.chat = null
        }
      }
    },

    async initBaseData() {
      console.log('initBaseData');
      // 重置数据
      await this.resetData()
      // 初始化客服
      this.initCustomerService()
      /* 数据库名、版本号 */
      this.ServiceDb.requestDB = this.ServiceDb.indexedDB.open(this.dbName, 1)
      console.log('this.ServiceDb.requestDB');
      console.log(this.ServiceDb.requestDB);
      this.ServiceDb.requestDB.onerror = () => {
        console.log("Why didn't you allow my web app to use IndexedDB?!")
        setTimeout(() => {
          this.canUpdate = true
        }, 2 * 1000)
      }

      this.ServiceDb.requestDB.onsuccess = (eve) => {
        this.ServiceDb.db = eve.target.result
        const objectStore = this.ServiceDb.db.transaction('service', 'readwrite').objectStore('service')
        const request = objectStore.index('userId').openCursor(null)
        request.onsuccess = (event) => {
          const cursor = event.target.result
          if (cursor) {
            if (this.userId !== cursor.value.userId) {
              objectStore.clear()
              this.getPageList()
            } else {
              cursor.continue()
            }
          } else {
            this.getPageList()
          }
        }
        request.onerror = (err) => {
          console.log('userId openCursor error==>', err)
          setTimeout(() => {
            this.canUpdate = true
          }, 2 * 1000)
        }
      }
      /* 数据库CustomerService版本升级或创建时触发 */
      this.ServiceDb.requestDB.onupgradeneeded = (eve) => {
        console.log('onupgradeneeded', eve)
        this.ServiceDb.db = eve.target.result
        /**
         * 创建一个objectStore来保存有关我们客户的信息。id为主键
         */
        let objectStore = null
        if (!this.ServiceDb.db.objectStoreNames.contains('service')) {
          objectStore = this.ServiceDb.db.createObjectStore('service', {
            keyPath: 'id'
          })
          /* 创建索引以按名称搜索 */
          objectStore.createIndex('type', ['type', 'createDate'], {
            unique: false
          })
          objectStore.createIndex('createTime', 'createTime', { unique: false })
          objectStore.createIndex('userId', 'userId', { unique: false })
          objectStore.createIndex('robotOrCustomer', 'robotOrCustomer', { unique: false })
        } else {
          objectStore = eve.target.transaction.objectStore('service')
        }
      }
    },

    clearDBData() {
      const objectStore = this.ServiceDb.db.transaction('service', 'readwrite').objectStore('service')
      objectStore.clear()
    },

    initPictureFn() {
      // Web 端发送图片消息示例2- 传入 File 对象
      // 先在页面上添加一个 id 为 "testPasteInput" 的消息输入框
      // 如 <input type="text" id="testPasteInput" placeholder="截图后粘贴到输入框中" size="30" />
      ; (document.getElementById('testPasteInput')).addEventListener('paste', (e) => {
        const clipboardData = e.clipboardData
        let file
        let fileCopy
        if (clipboardData && clipboardData.files && clipboardData.files.length > 0) {
          file = clipboardData.files[0]
          // 图片消息发送成功后，file 指向的内容可能被浏览器清空，如果接入侧有额外的渲染需求，可以提前复制一份数据
          fileCopy = file.slice()
        }
        this.tabLoading = true

        if (typeof file === 'undefined') {
          console.warn('file 是 undefined，请检查代码或浏览器兼容性！')
          this.tabLoading = false
          return
        }
        this.inputDisabled = true
        this.content = ''

        // 1. 创建消息实例，接口返回的实例可以上屏
        const message = this.chat.createImageMessage({
          to: this.customerUserId,
          conversationType: TencentCloudChat.TYPES.CONV_C2C,
          payload: {
            file: file
          },
          onProgress: function (event) {
            console.log('file uploading:', event)
          }
        })

        // 2. 发送消息
        this.chat
          .sendMessage(message)
          .then((res) => {
            this.content = ''
            if (res.code === 0 && res.data.message.payload.imageInfoArray) {
              const sendImage = res.data.message.payload.imageInfoArray.filter((v) => v.type === 0)[0]
              const imgDom = `<img src="${sendImage.imageUrl}" style="width:200px; vertical-align:middle; object-fit: cover;">`
              const params = {
                id: message.ID,
                type: '1',
                avatar: '',
                content: imgDom,
                userId: this.userId,
                createTime: common.parseTime(new Date()),
                createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
                list: [],
                pageOption: {},
                timeStamp: Date.now(),
                robotOrCustomer: '2'
              }
              this.content = ''
              this.queueList.push(params)
              this.list.push(params)
              this.$nextTick(() => {
                this.scrollTo()
              })
            }
          })
          .finally(() => {
            this.tabLoading = false
            this.inputDisabled = false
          })
      })
    },

    base64ToFile(dataurl, filename) {
      // 获取到base64编码
      const arr = dataurl.split(',')
      // 将base64编码转为字符串
      const bstr = window.atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n) // 创建初始化为0的，包含length个元素的无符号整型数组
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {
        type: 'image/png'
      })
    },

    // 初始化截图插件
    initScreenShot() {
      const config = {
        enableWebRtc: true,
        wrcReplyTime: 1000,
        level: 100000,
        writeBase64: false,
        hiddenToolIco: {
          save: true
        },
        hiddenScrollBar: {
          state: true,
          fillState: true
        },
        completeCallback: (res) => {
          this.tabLoading = true

          if (!res.base64) {
            console.warn('没有图片资源')
            this.tabLoading = false
            return
          }
          this.inputDisabled = true
          this.content = ''
          const file = this.base64ToFile(res.base64, `${new Date().getTime()}.png`)

          // 1. 创建消息实例，接口返回的实例可以上屏
          const message = this.chat.createImageMessage({
            to: this.customerUserId,
            conversationType: TencentCloudChat.TYPES.CONV_C2C,
            payload: {
              file: file
            },
            onProgress: function (event) {
              console.log('file uploading:', event)
            }
          })

          // 2. 发送消息
          this.chat
            .sendMessage(message)
            .then((res) => {
              this.content = ''
              if (res.code === 0 && res.data.message.payload.imageInfoArray) {
                const sendImage = res.data.message.payload.imageInfoArray.filter((v) => v.type === 0)[0]
                const imgDom = `<img src="${sendImage.imageUrl}" style="width:200px; vertical-align:middle; object-fit: cover;">`
                const params = {
                  id: message.ID,
                  type: '1',
                  avatar: '',
                  content: imgDom,
                  userId: this.userId,
                  createTime: common.parseTime(new Date()),
                  createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
                  list: [],
                  pageOption: {},
                  timeStamp: Date.now(),
                  robotOrCustomer: '2'
                }
                this.content = ''
                this.queueList.push(params)
                this.list.push(params)
                this.$nextTick(() => {
                  this.scrollTo()
                })
              }
            })
            .finally(() => {
              this.tabLoading = false
              this.inputDisabled = false
            })

          if (this.$route.path === '/answer') {
            handleFullScreen(true)
          }
        },
        closeCallback: (res) => {
          console.log('closeCallback', res)
          if (this.$route.path === '/answer') {
            handleFullScreen(true)
          }
        },
        triggerCallback: (res) => {
          console.log('triggerCallback', res)
        },
        cancelCallback: (res) => {
          console.log('cancelCallback', res)
          if (this.$route.path === '/answer') {
            handleFullScreen(true)
          }
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          if (window.ipcRenderer) {
            if (this.tabLoading) {
              return
            }
            this.tabLoading = true
            electronSendMessage('customCapturePage', true)
            window.ipcRenderer.receive('customElectonAction', async (data) => {
              window.ipcRenderer.offReceive('customElectonAction')
              const urls = await mergeImgs(data)
              if (urls) {
                this.inputDisabled = true
                this.content = ''
                const file = this.base64ToFile(urls, `${new Date().getTime()}.png`)

                // 1. 创建消息实例，接口返回的实例可以上屏
                const message = this.chat.createImageMessage({
                  to: this.customerUserId,
                  conversationType: TencentCloudChat.TYPES.CONV_C2C,
                  payload: {
                    file: file
                  },
                  onProgress: function (event) {
                    console.log('file uploading:', event)
                  }
                })

                // 2. 发送消息
                this.chat
                  .sendMessage(message)
                  .then((res) => {
                    this.content = ''
                    if (res.code === 0 && res.data.message.payload.imageInfoArray) {
                      const sendImage = res.data.message.payload.imageInfoArray.filter((v) => v.type === 0)[0]
                      const imgDom = `<img src="${sendImage.imageUrl}" style="width:200px; vertical-align:middle; object-fit: cover;">`
                      const params = {
                        id: message.ID,
                        type: '1',
                        avatar: '',
                        content: imgDom,
                        userId: this.userId,
                        createTime: common.parseTime(new Date()),
                        createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
                        list: [],
                        pageOption: {},
                        timeStamp: Date.now(),
                        robotOrCustomer: '2'
                      }
                      this.content = ''
                      this.queueList.push(params)
                      this.list.push(params)
                      this.$nextTick(() => {
                        this.scrollTo()
                      })
                    }
                  })
                  .finally(() => {
                    this.tabLoading = false
                    this.inputDisabled = false
                  })
              } else {
                this.tabLoading = false
              }
              setTimeout(() => {
                this.tabLoading = false
              }, 3000)
            })
            return
          }
          // eslint-disable-next-line no-new
          new ScreenShot(config)
        }, 500)
      })
    },

    onSdkReady(event) {
      console.log('onSdkReady==>', event)
      this.sdkReady = true
      this.tabLoading = false
      this.chat.updateMyProfile({
        nick: this.userName
      })
      const message = this.chat.createCustomMessage({
        to: this.customerUserId,
        conversationType: TencentCloudChat.TYPES.CONV_C2C,
        payload: {
          data: JSON.stringify({
            customerServicePlugin: 0,
            src: '7'
          })
        }
      })
      this.chat.sendMessage(message).then((res) => console.log('初始第一次发送成功', res))
      if (this.userInfo) {
        const userInfoMessage = this.chat.createTextMessage({
          to: this.customerUserId,
          conversationType: TencentCloudChat.TYPES.CONV_C2C,
          payload: {
            text: this.userInfo
          }
        })
        this.chat.sendMessage(userInfoMessage)
      }
    },

    onSdkNotReady(event) {
      console.log('onSdkNotReady==>', event)
      // if (this.chat) {
      //     this.chat.login({ userID: this.userId, userSig: this.userSig })
      // }
    },

    onMessageReceived(event) {
      // event.data - 存储 Message 对象的数组 - [Message]
      const messageList = event.data
      messageList.forEach((message) => {
        console.log('onMessageReceived==>', message)
        if (message.type === TencentCloudChat.TYPES.MSG_CUSTOM) {
          // 自定义消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.CustomPayload
          if (message.payload.data) {
            const data = JSON.parse(message.payload.data)
            if (data.src === '26' && data.content.command === 'updateSeatStatus') {
              if (data.content.content === 'inSeat') {
                const store = this.ServiceDb.db.transaction('service', 'readonly').objectStore('service')
                const count = store.count()
                const list = []
                store.index('type').openCursor(this.ServiceDb.IDBKeyRange.only(['8', common.parseTime(new Date(), '{y}-{m}-{d}')])).onsuccess = (event) => {
                  const cursor = event.target.result
                  if (cursor) {
                    const date = new Date(cursor.value.createTime)
                    const timeStamp = Date.parse(date)
                    list.push(timeStamp)
                    cursor.continue()
                  } else {
                    if (count.result === 0) {
                      this.insertIdentification(message)
                    } else {
                      if (Date.now() - Math.max.apply(null, list) > 10 * 60 * 1000) {
                        this.insertIdentification(message)
                      }
                    }
                  }
                }
              }
            }
            if (data.src === '21' && data.content.type === 0) {
              const params = {
                id: message.ID,
                type: '7',
                avatar: '',
                content: data.content.header,
                userId: this.userId,
                createTime: common.parseTime(new Date()),
                createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
                list: [],
                pageOption: {},
                timeStamp: Date.now(),
                robotOrCustomer: '2'
              }
              this.queueList.push(params)
              this.list.push(params)
              this.$nextTick(() => {
                this.scrollTo()
              })
            }
            // 无坐席在线
            if (data.src === '18') {
              this.selectedSkill = false
              sessionStorage.setItem('selectedSkill', 'false')
            }
          }
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_TEXT) {
          // 文本消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.TextPayload
          if (message.payload.text) {
            const params = {
              id: message.ID,
              type: '7',
              avatar: '',
              content: message.payload.text,
              userId: this.userId,
              createTime: common.parseTime(new Date()),
              createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
              list: [],
              pageOption: {},
              timeStamp: Date.now(),
              robotOrCustomer: '2'
            }
            this.queueList.push(params)
            this.list.push(params)
            this.$nextTick(() => {
              this.scrollTo()
            })
          }
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_IMAGE) {
          // 图片消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.ImagePayload
          if (message.payload.imageInfoArray) {
            const sendImage = message.payload.imageInfoArray.filter((v) => v.type === 0)[0]
            const imgDom = `<img src="${sendImage.imageUrl}" style="width: 200px; vertical-align:middle; object-fit: cover;">`
            const params = {
              id: message.ID,
              type: '7',
              avatar: '',
              content: imgDom,
              userId: this.userId,
              createTime: common.parseTime(new Date()),
              createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
              list: [],
              pageOption: {},
              timeStamp: Date.now(),
              robotOrCustomer: '2'
            }
            this.queueList.push(params)
            this.list.push(params)
            this.$nextTick(() => {
              this.scrollTo()
            })
          }
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_AUDIO) {
          // 音频消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.AudioPayload
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_VIDEO) {
          // 视频消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.VideoPayload
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_FILE) {
          // 文件消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.FilePayload
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_MERGER) {
          // 合并消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.MergerPayload
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_LOCATION) {
          // 地理位置消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.LocationPayload
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_GRP_TIP) {
          // 群提示消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.GroupTipPayload
          return
        }
        if (message.type === TencentCloudChat.TYPES.MSG_GRP_SYS_NOTICE) {
          // 群系统通知 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.GroupSystemNoticePayload
        }
      })
    },

    onNetStateChange(event) {
      console.log('onNetStateChange===>', event)
      // event.data.state 当前网络状态，枚举值及说明如下：
      // TencentCloudChat.TYPES.NET_STATE_CONNECTED - 已接入网络
      // TencentCloudChat.TYPES.NET_STATE_CONNECTING
      // 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
      // TencentCloudChat.TYPES.NET_STATE_DISCONNECTED
      // 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
    },

    onKickedOut(event) {
      console.log('onKickedOut===>', event.data.type)
      // chat.destroy()
      // TencentCloudChat.TYPES.KICKED_OUT_MULT_ACCOUNT(Web端，同一账号，多页面登录被踢)
      // TencentCloudChat.TYPES.KICKED_OUT_MULT_DEVICE(同一账号，多端登录被踢)
      // TencentCloudChat.TYPES.KICKED_OUT_USERSIG_EXPIRED(签名过期)
      // TencentCloudChat.TYPES.KICKED_OUT_REST_API(REST API kick 接口踢出)
    },

    initCustomerService() {
      console.log('this.SDKAppID = ' + this.SDKAppID);
      const options = {
        SDKAppID: this.SDKAppID // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
      }
      if (!this.chat) {
        this.chat = TencentCloudChat.create(options)
        this.chat.setLogLevel(1) // 普通级别，日志量较多，接入时建议使用
        // chat.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
        // 注册腾讯云即时通信 IM 上传插件
        this.chat.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })
        this.initPictureFn()

        this.chat.on(TencentCloudChat.EVENT.SDK_READY, this.onSdkReady)
        this.chat.on(TencentCloudChat.EVENT.SDK_NOT_READY, this.onSdkNotReady)
        this.chat.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, this.onMessageReceived)
        this.chat.on(TencentCloudChat.EVENT.NET_STATE_CHANGE, this.onNetStateChange)
        this.chat.on(TencentCloudChat.EVENT.KICKED_OUT, this.onKickedOut)
      }
    },

    handleClickScreenShot() {
      if (!this.sdkReady) return
      this.initScreenShot()
    },

    async handleOpenCustomer() {
      // 保证注册时监听事件都已经注册
      if (this.chat) {
        this.chat
          .login({ userID: this.userId, userSig: this.userSig })
          .then((res) => {
            if (res.data.repeatLogin === true) {
              this.tabLoading = false
              this.sdkReady = true
            }
          })
          .catch(() => {
            this.tabLoading = false
          })
      }
    },

    // 点击客服
    handleNextContent() {
      this.currentMode = '2'
      sessionStorage.setItem('currentMode', '2')
      this.handleOpenCustomer()
    },

    rewriteKeypress() {
      this.$nextTick(() => {
        const enterings = this.$refs.enterings
        enterings.$el.addEventListener('keypress', (el) => {
          const els = el || window.event
          console.log(els)
        })
      })
    },

    // 聊天内容图片点击放大
    imageChgange(el, str) {
      if (el.target.nodeName === 'IMG') {
        const reg = /(\/|http)[^>]+\.(jpg|jpeg|png|gif)/g
        const list = str.match(reg) || []
        if (list.length !== 0) {
          this.srcUrl = el.target.currentSrc
          const name = this.srcUrl.substr(this.srcUrl.lastIndexOf('/') + 1).toLowerCase()
          const index = list.findIndex(v => v.search(name) !== -1)
          this.srcList = list.map((row, i) => {
            if (i === index) {
              return this.srcUrl
            }
            return row
          })
            ; (this.$refs.PreviewImage).showImage()
        } else {
          this.srcUrl = el.target.currentSrc
          this.srcList = [this.srcUrl]
            ; (this.$refs.PreviewImage).showImage()
        }
      }
    },

    // 聊天框缩放
    onDragScale() {
      this.$nextTick(() => {
        const dragPanel = document.getElementById('dragPanel')
        const dragIcon = document.getElementById('dragIcon')
        let disX = 0 // 鼠标按下时光标的X值
        let disY = 0 // 鼠标按下时光标的Y值
        let disW = 0 // 拖拽前div的宽
        let disH = 0 // 拖拽前div的高
        const panelw = dragPanel.offsetWidth
        const panelh = dragPanel.offsetHeight
        const clientWidth = document.documentElement.clientWidth
        const clientHeight = document.documentElement.clientHeight
        dragIcon.onmousedown = function (el) {
          const els = el || window.event
          disX = els.clientX
          disY = els.clientY
          disW = dragPanel.offsetWidth
          disH = dragPanel.offsetHeight
          console.log('GGGGGG', disX, disY, panelw, panelh, clientWidth, clientHeight)
          document.onmousemove = function (ev) {
            const evs = ev || window.event
            let W = disX - evs.clientX + disW
            let H = disY - evs.clientY + disH
            if (W < panelw / 2) {
              W = panelw / 2
            }
            if (W > clientWidth / 2) {
              W = clientWidth / 2
            }
            if (H < panelh / 2) {
              H = panelh / 2
            }
            if (H > clientHeight - 50) {
              H = clientHeight - 50
            }
            dragPanel.style.width = W + 'px'
            dragPanel.style.height = H + 'px'
          }

          document.onmouseup = function () {
            document.onmousemove = null
            document.onmouseup = null
          }
        }
      })
    },

    // 获取tab列表
    async getDictType() {
      try {
        const { data = [] } = await getDictType({
          path: this.$route.name
        })
        console.log(data);
        this.tabList = this.useHotline ? [{ key: '人工客服', value: 'customer' }].concat(data.data) : data.data
      } catch (error) {
        console.log(error)
      }
    },

    // 猜你想问数据分页
    changeBatch(row) {
      if (row.pageOption.total <= row.pageOption.pageSize) {
        return
      }
      const list = row.content.filter(
        (values, index) => index + 1 > row.pageOption.page * row.pageOption.pageSize && index < (row.pageOption.page + 1) * row.pageOption.pageSize
      )
      if (row.pageOption.total <= row.pageOption.page * row.pageOption.pageSize + list.length) {
        this.$set(row, 'pageOption', {
          page: 0,
          pageSize: 4,
          total: row.pageOption.total
        })
      } else {
        this.$set(row, 'pageOption', {
          page: row.pageOption.page + 1,
          pageSize: 4,
          total: row.pageOption.total
        })
      }
      this.$set(row, 'list', list)
    },

    // 显示时1小时后插入一条时间数据
    async handleShow() {
      if (!this.canUpdate) return
      this.show = true
      await this.getDictType()
      if (this.currentMode === '1') {
        /* 单独查数据 */
        const store = this.ServiceDb.db.transaction('service', 'readonly').objectStore('service')
        const count = store.count()
        const list = []
        store.index('type').openCursor(this.ServiceDb.IDBKeyRange.only(['3', common.parseTime(new Date(), '{y}-{m}-{d}')])).onsuccess = (event) => {
          const cursor = event.target.result
          if (cursor) {
            const date = new Date(cursor.value.createTime)
            const timeStamp = Date.parse(date)
            list.push(timeStamp)
            cursor.continue()
          } else {
            if (count.result === 0) {
              this.insertTime()
            } else {
              if (Date.now() - Math.max.apply(null, list) > 3600 * 1000) {
                this.insertTime()
              }
            }
          }
        }
        this.onceShowCs()
        this.$nextTick(() => {
          this.scrollTo()
          this.onDragScale()
          // 用户获取猜你所想
          // const { meta } = this.$route
          // const data = this.tabList.find((row) => row.dictValue === (meta ).CustomerService)
          // if (data) {
          //     this.editableTabsValue = data.dictValue
          //     this.tabLoading = true
          //     const values = this.tabList.find((row) => row.dictValue === this.editableTabsValue)
          //     this.handleSeed(values.dictLabel, values.dictValue, false)
          // }
          this.tabLoading = true
          this.handleInitSeed('', '')
        })
      } else {
        this.handleOpenCustomer()
        this.$nextTick(() => {
          this.scrollTo()
          this.onDragScale()
        })
      }
    },

    // 判断用户是否当天第一次打开插入问候语 type=6
    onceShowCs() {
      const params = {
        id: `app-${Date.now()}`,
        type: '6',
        avatar: '',
        content: this.openWindowDescription,
        userId: this.userId,
        createTime: common.parseTime(new Date()),
        createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
        list: [],
        pageOption: {},
        timeStamp: Date.now(),
        robotOrCustomer: '1'
      }
      const store = this.ServiceDb.db.transaction('service', 'readonly').objectStore('service')
      store.index('type').openCursor(this.ServiceDb.IDBKeyRange.only(['6', common.parseTime(new Date(), '{y}-{m}-{d}')])).onsuccess = (event) => {
        const cursor = event.target.result
        if (!cursor) {
          this.queueList.push(params)
          this.list.push(params)
          this.$nextTick(() => {
            this.scrollTo()
          })
        }
      }
    },

    // 添加时间 type=3
    insertTime() {
      setTimeout(() => {
        const params = {
          id: `app-${Date.now()}`,
          type: '3',
          avatar: '',
          content: common.parseTime(new Date(), '{h}:{i}:{s}'),
          userId: this.userId,
          createTime: common.parseTime(new Date()),
          createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
          list: [],
          pageOption: {},
          timeStamp: Date.now(),
          robotOrCustomer: '1'
        }
        this.queueList.push(params)
        this.list.push(params)
      }, 1000)
    },

    // 插入人工客服type=5
    insertConsultant() {
      const params = {
        id: `app-${Date.now()}`,
        type: '5',
        avatar: '',
        content: this.contactUsDescription || `未获取到满意的回复？可以联系我们：${this.consultationHotline}`,
        // content: `未获取到满意的回复？可以联系我们：${this.consultationHotline}`,
        // content: '未获取到满意的回复？点击此处转人工客服',
        userId: this.userId,
        createTime: common.parseTime(new Date()),
        createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
        list: [],
        pageOption: {},
        timeStamp: Date.now(),
        robotOrCustomer: '1'
      }

      this.list.push(params)
      this.queueList.push(params)
      this.$nextTick(() => {
        this.scrollTo()
      })
    },

    // 插入人工客服标识位type = 8
    insertIdentification(message) {
      const params = {
        id: message.ID,
        type: '8',
        avatar: '',
        content: '当前人工客服已就位',
        userId: this.userId,
        createTime: common.parseTime(new Date()),
        createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
        list: [],
        pageOption: {},
        timeStamp: Date.now(),
        robotOrCustomer: '2'
      }
      this.queueList.push(params)
      this.list.push(params)
      this.$nextTick(() => {
        this.scrollTo()
      })
    },

    // 插入猜你想问数据type = 4
    insertContent(datas) {
      setTimeout(() => {
        const list = datas.filter((row, index) => index < 4)
        const params = {
          id: `app-${Date.now()}`,
          type: '4',
          avatar: '',
          content: datas,
          list,
          pageOption: {
            page: 1,
            pageSize: 4,
            total: datas.length
          },
          userId: this.userId,
          createTime: common.parseTime(new Date()),
          createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
          timeStamp: Date.now(),
          robotOrCustomer: '1'
        }
        this.list.push(params)
        this.queueList.push(params)
        this.scrollTo()
      }, 1000)
    },

    // 插入客服技能组type = 9
    insertSkillGroup(datas) {
      setTimeout(() => {
        const params = {
          id: `app-${Date.now()}`,
          type: '9',
          avatar: '',
          content: datas,
          list: [],
          pageOption: {},
          userId: this.userId,
          createTime: common.parseTime(new Date()),
          createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
          timeStamp: Date.now(),
          robotOrCustomer: '1'
        }
        this.list.push(params)
        this.queueList.push(params)
        this.scrollTo()
      }, 1000)
    },

    // 检测用户行为时间间隔
    async householdBehavior() {
      const fn = () => {
        return new Promise((resolve, reject) => {
          const store = this.ServiceDb.db.transaction('service', 'readonly').objectStore('service')
          store.index('type').openCursor(this.ServiceDb.IDBKeyRange.only(['5', common.parseTime(new Date(), '{y}-{m}-{d}')])).onsuccess = (event) => {
            const cursor = event.target.result
            if (!cursor) {
              resolve(true)
            } else {
              reject(new Error('error'))
            }
          }
        })
      }
      try {
        await fn()
        /* 单独查数据 */
        if (this.ServiceDb.db) {
          const store = this.ServiceDb.db.transaction('service', 'readonly').objectStore('service')
          const list = []
          store.index('type').openCursor(this.ServiceDb.IDBKeyRange.only(['1', common.parseTime(new Date(), '{y}-{m}-{d}')]), 'prev').onsuccess = (event) => {
            const cursor = event.target.result
            if (cursor) {
              const date = new Date(cursor.value.createTime)
              const timeStamp = Date.now() - Date.parse(date)
              list.push(timeStamp)
              if (list.length <= 4) {
                cursor.continue()
              } else {
                const sum = list.reduce((prev, item) => {
                  return prev + item
                })
                const values = sum / 1000 / 60
                if (values < 10) {
                  this.insertConsultant()
                }
              }
            }
          }

          this.$nextTick(() => {
            this.scrollTo()
          })
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 向上加载数据
    scrollLoadMore() {
      if (this.list.length >= this.pageOption.total) {
        return
      }
      if (this.loading) {
        return
      }
      this.pageOption.page += 1
      this.getPageList()
    },

    // 执行事务分页加载数据
    getPageList() {
      let index = null
      this.loading = true
      /* 事务全表查询 */
      const store = this.ServiceDb.db.transaction('service', 'readonly').objectStore('service')

      const count = store.count()
      const request = store.index('createTime').openCursor(null, 'prev' /* next or prev */)
      request.onsuccess = (event) => {
        const cursor = event.target.result
        if (cursor) {
          if (index === this.pageOption.pageSize - 1) {
            this.list.push(cursor.value)
            this.pageOption.total = count.result
            setTimeout(() => (this.loading = false), 500)
            this.canUpdate = true
            return
          }
          if (index === null && this.pageOption.page !== 1) {
            index = 0
            cursor.advance((this.pageOption.page - 1) * this.pageOption.pageSize)
          } else {
            index++
            this.list.push(cursor.value)
            cursor.continue()
          }
        } else {
          setTimeout(() => (this.loading = false), 500)
          this.pageOption.total = count.result
          this.canUpdate = true
        }
      }

      request.onerror = (err) => {
        console.log('createTime openCursor error==>', err)
        setTimeout(() => {
          this.canUpdate = true
        }, 2 * 1000)
      }
    },

    handleClickLink(row) {
      if (this.tabLoading) {
        if (this.loadingText) return
        this.loadingText = true
        setTimeout(() => {
          this.loadingText = false
        }, 1000)
        return
      }
      this.tabLoading = true
      const params = {
        id: `app-${Date.now()}`,
        type: '1',
        avatar: '',
        content: row.questionName,
        userId: this.userId,
        createTime: common.parseTime(new Date()),
        createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
        list: [],
        pageOption: {},
        timeStamp: Date.now(),
        robotOrCustomer: '1'
      }
      this.list.push(params)
      this.queueList.push(params)
      this.searchQuestionDetail(row.id)
    },

    // 点击客服技能组
    async handleClickCustomer(row) {
      if (this.selectedSkill) {
        this.$message.warning('人工客服已对接，请输入您需要咨询的内容。')
        return
      }
      this.selectedSkill = true
      sessionStorage.setItem('selectedSkill', 'true')
      if (this.skillLock) return
      this.skillLock = true
      if (this.currentMode === '2') {
        if (this.chat) {
          if (this.sdkReady) {
            const message = this.chat.createCustomMessage({
              to: this.customerUserId,
              conversationType: TencentCloudChat.TYPES.CONV_C2C,
              payload: {
                data: JSON.stringify({
                  customerServicePlugin: 0,
                  src: '27'
                })
              }
            })
            this.chat.sendMessage(message).then((res) => console.log('断开会话', res))
          }
          await this.chat.logout()
        }
      }
      try {
        await bindCandidateSkillGroupApi({
          candidateId: this.userId,
          examId: this.examId,
          officeId: this.officeId,
          skillGroupId: row.value
        })
        setTimeout(() => {
          this.currentMode = '2'
          sessionStorage.setItem('currentMode', '2')
          this.handleOpenCustomer()
          this.skillLock = false
        }, 500)
      } catch (err) {
        console.log(err);
        setTimeout(() => {
          this.currentMode = '2'
          sessionStorage.setItem('currentMode', '2')
          this.handleOpenCustomer()
          this.skillLock = false
        }, 500)
      }
    },

    handleClickTab() {
      if (this.tabLoading) {
        if (this.loadingText) return
        this.loadingText = true
        setTimeout(() => {
          this.loadingText = false
        }, 1000)
        return
      }
      this.tabLoading = true
      const values = this.tabList.find((row) => row.value === this.editableTabsValue)
      this.handleSeed(values.key, values.value)
    },

    handleEnterSeed() {
      if (this.tabLoading) {
        if (this.loadingText) return
        this.loadingText = true
        setTimeout(() => {
          this.loadingText = false
        }, 1000)
        return
      }
      this.tabLoading = true
      this.handleSeed(this.content)
    },

    async handleSeed(str, questionCategory = '', type = true) {
      const value = this.content || str
      if (typeof value !== 'string') {
        this.tabLoading = false
        return
      }
      if (!value || !value.trim()) {
        this.content = ''
        this.tabLoading = false
        return
      }
      if (!this.tabLoading) {
        this.tabLoading = true
      }
      if (this.currentMode === '1') {
        const params = {
          id: `app-${Date.now()}`,
          type: '1',
          avatar: '',
          content: value,
          userId: this.userId,
          createTime: common.parseTime(new Date()),
          createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
          list: [],
          pageOption: {},
          timeStamp: Date.now(),
          robotOrCustomer: '1'
        }
        if (type) {
          this.list.push(params)
          this.queueList.push(params)
        }
        this.content = ''
        this.scrollTo()
        if (value.includes('人工')) {
          try {
            const res = await getSkillGroupListApi({
              candidateId: this.userId,
              examId: this.examId,
              officeId: this.officeId
            })
            console.log(res);
            this.insertSkillGroup(
              res.data.data.map((v) => ({
                label: v.skillGroupDesc,
                value: v.skillGroupId
              })) || []
            )
          } catch (err) {
            console.log(err);
            setTimeout(() => {
              this.currentMode = '2'
              sessionStorage.setItem('currentMode', '2')
              this.handleOpenCustomer()
            }, 500)
          }
          this.tabLoading = false

          return
        }
        try {
          const { data } = await searchQuestion({
            size: 16,
            current: 0,
            questionText: questionCategory ? '' : value,
            questionCategory,
            path: this.$route.name,
            officeId: this.officeId
          })
          if (data.data.questionContent) {
            this.insertMessage(data.data.questionContent)
          } else if (questionCategory === '') {
            this.defaultMsg()
          }

          if (data.data.questionInfos && data.data.questionInfos.length > 0) {
            this.insertContent(data.data.questionInfos)
          }
        } catch (error) {
          console.log(error)
        }
        setTimeout(() => {
          this.tabLoading = false
          this.scrollTo()
        }, 500)
        setTimeout(() => {
          this.householdBehavior()
        }, 1500)
      } else {
        if (this.sdkReady) {
          const params = {
            id: `app-${Date.now()}`,
            type: '1',
            avatar: '',
            content: value,
            userId: this.userId,
            createTime: common.parseTime(new Date()),
            createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
            list: [],
            pageOption: {},
            timeStamp: Date.now(),
            robotOrCustomer: '2'
          }
          if (type) {
            this.list.push(params)
            this.queueList.push(params)
          }
          this.content = ''
          this.scrollTo()
          const message = this.chat.createTextMessage({
            to: this.customerUserId,
            conversationType: TencentCloudChat.TYPES.CONV_C2C,
            payload: {
              text: value
            }
          })
          this.chat.sendMessage(message)
          setTimeout(() => {
            this.tabLoading = false
          }, 500)
        } else {
          this.$message({
            type: 'warning',
            message: '聊天初始化异常，请刷新页面重试'
          })
          setTimeout(() => {
            this.tabLoading = false
          }, 500)
        }
      }
    },

    async handleInitSeed(str, questionCategory = '') {
      const value = this.content || str
      if (typeof value !== 'string') {
        this.tabLoading = false
        return
      }
      if (!this.tabLoading) {
        this.tabLoading = true
      }
      if (this.currentMode === '1') {
        this.content = ''
        this.scrollTo()
        try {
          const { data } = await searchQuestion({
            size: 16,
            current: 0,
            questionText: questionCategory ? '' : value,
            questionCategory,
            path: this.$route.name,
            officeId: this.officeId
          })
          if (data.questionContent) {
            this.insertMessage(data.questionContent)
          }

          if (data.questionInfos && data.questionInfos.length > 0) {
            this.insertContent(data.questionInfos)
          }
        } catch (error) {
          console.log(error)
        }
        setTimeout(() => {
          this.tabLoading = false
          this.scrollTo()
        }, 500)
      }
    },
    async searchQuestionDetail(id) {
      try {
        const { data } = await searchQuestionDetail({ id })
        if (data.data.questionContent) {
          this.insertMessage(data.data.questionContent)
        } else {
          this.defaultMsg()
        }
      } catch (error) {
        console.log(error)
      }
      this.scrollTo()
      setTimeout(() => {
        this.tabLoading = false
        this.householdBehavior()
      }, 1500)
    },

    // 返回默认数据
    defaultMsg() {
      setTimeout(() => {
        const params = {
          id: `app-${Date.now()}`,
          type: '2',
          avatar: '',
          content: this.contactUsDescription,
          userId: this.userId,
          createTime: common.parseTime(new Date()),
          createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
          list: [],
          pageOption: {},
          timeStamp: Date.now(),
          robotOrCustomer: '1'
        }

        this.list.push(params)
        this.queueList.push(params)
        this.scrollTo()
      }, 1000)
    },

    // 后台返回数据匹配
    insertMessage(questionContent) {
      setTimeout(() => {
        const params = {
          id: `app-${Date.now()}`,
          type: '2',
          avatar: '',
          content: questionContent,
          userId: this.userId,
          createTime: common.parseTime(new Date()),
          createDate: common.parseTime(new Date(), '{y}-{m}-{d}'),
          list: [],
          pageOption: {},
          timeStamp: Date.now(),
          robotOrCustomer: '1'
        }

        this.list.push(params)
        this.queueList.push(params)
        this.scrollTo()
      }, 1000)
    },

    scrollTo() {
      const el = document.getElementById('scrollbar').querySelector('.yks-contents')
      const y = el.scrollHeight
      const duration = 200
      const els = (document.getElementById('scrollbar')).querySelector('.el-scrollbar__wrap')
      const scrollTop = els.scrollTop
      const distance = y - scrollTop
      const scrollCount = duration / 10
      const everyDistance = parseInt((distance / scrollCount).toString())
      for (let index = 1; index <= scrollCount; index++) {
        setTimeout(function () {
          els.scrollBy(0, everyDistance)
        }, 10)
      }
    },

    insertDbContent(params) {
      console.log('BBBBBBBB', params)
      if (this.ServiceDb.db) {
        /* 事务插入数据 */
        this.ServiceDb.db.transaction('service', 'readwrite').objectStore('service').add(params)
      }
    },

    beforeDestroy() {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer)
        this.updateTimer = null
      }
      this.finishChat()
    },

    async finishChat() {
      if (this.chat) {
        if (this.sdkReady) {
          const message = this.chat.createCustomMessage({
            to: this.customerUserId,
            conversationType: TencentCloudChat.TYPES.CONV_C2C,
            payload: {
              data: JSON.stringify({
                customerServicePlugin: 0,
                src: '27'
              })
            }
          })
          this.chat.sendMessage(message).then((res) => console.log('断开会话', res))
        }

        await this.chat.destroy()
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../assets/scss/custom-theme/index.css';
@import '../../assets/scss/custom-theme/short.scss';

.customer-service-container {
  position: fixed;
  right: 5px;
  bottom: 100px;
}

.customer-service-icon {
  position: absolute;
  right: 0;
  bottom: 50px;
  width: 44px;
  text-align: center;
  font-size: 12px;
  background: url(../../assets/image/server-bg.png);
  background-repeat: no-repeat;
  background-size: 160% 160%;
  background-position: 50%;
  cursor: pointer;
  border-radius: 5px;
  overflow: hidden;
  text-align: center;
  padding: 6px 0;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
  color: #47476b;
  -webkit-box-shadow: 0 0 5px #a2a6ad;
  box-shadow: 0 0 5px #a2a6ad;

  img {
    display: inline-block;
    width: 26px;
    height: 26px;
    margin-bottom: 6px;
  }

  .icon-label {
    display: block;
  }
}

.customer {
  position: fixed;
  right: 10px;
  bottom: 30px;
  z-index: 100;

  &.customer-m {
    .yks-service-contents {
      width: 90vw;
    }
  }

  &.show-zindex {
    z-index: 1000;
  }

  .ql-editor {
    padding: 0;

    ::v-deep {
      img {
        max-width: 100%;
      }
    }
  }

  .sms-tabs {
    padding: 10px 10px 0;
    background: #ffffff;

    .tool-bar {
      height: 30px;
      line-height: 10px;

      .icon-message-top {
        height: 100%;
        font-size: 24px;
        margin-right: 10px;
        cursor: pointer;
      }
    }
  }

  .yks-content {
    padding: 10px;
    background: #ffffff;

    ::v-deep .el-textarea__inner {
      padding-bottom: 5px;
    }
  }

  .customer-service {
    position: absolute;
    right: 0px;
    bottom: 50px;
    width: 44px;
    background: url('https://obs-ogt.obs.cn-east-3.myhuaweicloud.com:443/tinymce/1685174265231-login-bg.png');
    background-repeat: no-repeat;
    background-size: 160% 160%;
    background-position: center;
    cursor: pointer;
    border-radius: 5px;
    overflow: hidden;
    text-align: center;
    padding: 6px 0;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -khtml-user-select: none;
    -o-user-select: none;
    user-select: none;
    color: #47476b;
    box-shadow: 0 0 5px #a2a6ad;
    font-size: 12px;

    &.customer-service-disabled {
      cursor: not-allowed;
    }

    ::v-deep .el-image {
      width: 60%;
      font-size: 12px;
    }
  }

  .yks-service-contents {
    box-shadow: 0 0 3px #2752e7;
    width: 500px;
    position: relative;
    overflow: hidden;
    border-radius: 5px;
    height: 600px;
    background-color: #e5ebfc;
    max-width: 100%;

    .service-title {
      height: 65px;
      display: flex;
      align-items: center !important;
      padding: 5px 20px;
      border-bottom: 1px solid #eee;
      background: url('https://obs-ogt.obs.cn-east-3.myhuaweicloud.com:443/tinymce/1685178476577-server-bg.png');
      background-repeat: no-repeat;
      background-size: 200% 160%;
      background-position: center;
      color: #000;
      position: relative;

      .yks-drag {
        position: absolute;
        top: 0;
        left: 0;
        cursor: nw-resize;
        z-index: 1000;
        width: 40px;
        height: 40px;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        -o-user-select: none;
        user-select: none;
      }

      .service-infos {
        div {
          font-size: 12px;
          margin-right: 20px;
        }

        & div:first-child {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 5px;
        }
      }

      i {
        font-weight: bold;
        font-size: 15px;
        cursor: pointer;
      }
    }

    .yks-app-scrollbar {
      position: relative;
      // overflow: auto;
      height: calc(100% - 190px);
      /deep/ .el-scrollbar__wrap {
        margin-bottom: 0 !important;
        margin-right: 0 !important;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 0;
          height: 0;
        }
      }

      .msg-content {
        border-radius: 3px;
        position: relative;
        font-size: 12px;
        line-height: 20px;

        &::after {
          content: '';
          display: inline-block;
          position: absolute;
          width: 10px;
          height: 10px;
          transform: rotate(45deg);
        }

        &.right-content {
          margin: 0 15px 0 40px;

          &::after {
            top: 10px;
            right: -3px;
            background: #d2deff;
          }
        }

        &.left-content {
          margin: 0 40px 0 15px;

          &::after {
            top: 10px;
            left: -3px;
            background: #ffffff;
          }
        }

        .yks-contents-right {
          white-space: break-spaces;
          background-color: #d2deff;
          display: inline-block;
          padding: 10px;
          border-radius: 3px;
          max-width: 100%;
          overflow: hidden;
        }

        .yks-contents-left {
          white-space: break-spaces;
          background-color: #ffffff;
          display: inline-block;
          padding: 10px;
          border-radius: 3px;
          max-width: 100%;
          overflow: hidden;
        }

        .yks-contents-sms {
          background-color: #ffffff;
          padding: 5px 10px 10px;
          border-radius: 3px;
          min-height: 137px;

          .guess {
            height: 36px;
            border-bottom: 1px solid #e6ebf5;
            margin-bottom: 5px;
          }

          .sms-batch {
            font-weight: bold;
            font-size: 13px;
          }

          .button-text {
            padding: 0;
          }

          .skill {
            &.disabled {
              color: #9dbef6;
            }
          }
        }
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        -webkit-box-shadow: inset 0 0 5px #e9e9e9;
        box-shadow: inset 0 0 5px #e9e9e9;
        background: #e9e9e9;
      }
    }

    .service-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }
  }

    .el-avatar {
      background: #d5dbe7;
    }

    .yks-contents {
      display: flex;
      padding: 10px 20px 0;
      flex-direction: column;
      flex: 1;
      &::before,
      &::after {
        content: '';
        display: table;
        clear: both;
      }
      /deep/ .el-divider {
        margin: 24px 0;
        background-color: #dcdfe6;
        display: inline-block;

        .el-divider__text {
          font-size: 14px;
          font-weight: 500;
          color: #303133;
          background-color: #e5ebfc;
        }
      }
    }

    /deep/ .el-tabs__header {
      border: none;
      margin-bottom: 0;

      .el-tabs__nav {
        border: none;
      }

      .el-tabs__nav-prev,
      .el-tabs__nav-next {
        line-height: 30px;
      }

      .el-tabs__item {
        border: none;
        background-color: #e9f3ff;
        color: #707070;
        font-size: 12px;
        height: 30px;
        line-height: 30px;
        margin-right: 10px;
        border-radius: 3px;
        padding: 0 10px;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        -o-user-select: none;
        user-select: none;
      }
    }

    // .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item {
    //     padding: 0 10px;
    // }

    // tabs
    /deep/ .el-tabs {
      min-height: unset;
      position: unset;
      z-index: unset;

      // // header
      >.el-tabs__header {
        width: 100%;
        min-height: unset;
        margin: 0;

        >.el-tabs__nav-wrap {
          min-height: unset;
          overflow: hidden;

          >.el-tabs__nav-scroll {
            min-height: unset;
            overflow: hidden;
          }

          &::after {
            display: none;
          }

          .el-tabs__active-bar {
            display: none;
          }

          .el-tabs__item {
            height: unset;
            padding: 0 10px;
            display: inline-flex;
            align-items: center;
            text-align: center;

            &.is-active {
              color: #707070;
            }
          }

          .el-icon-arrow-right {
            font-size: 12px;
            color: unset;
          }

          .el-icon-arrow-left {
            font-size: 12px;
            color: unset;
          }
        }
      }
    }

  .mt6 {
    margin-top: 6px;
  }

  .el-button--primary {
    width: 120px;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    border-radius: 8px;
  }
  @media only screen and (max-width: 1367px) {
    .yks-service-contents {
      height: 450px;
    }
  }
  @media only screen and (max-width: 768px) {
      .el-button.fs-12 {
          font-size: 12px;
      }
      .el-button--primary {
          width: 120px;
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home/customerServiceDialog.vue